import classnames from "classnames";
import React from "react";
import { Link as RRLink } from "react-router";
import { Plugin } from "slate-react";
import { INLINES } from "../../html";
import { EditTooltip } from "./editTooltip";
import { getFocusedLink } from "./linkUtils";

const { type } = INLINES.LINK;

/**
 * Render a 'link' inline node
 */
export const renderLink: Plugin = {
  renderInline: (props, controller, next) => {
    const { attributes, children, node } = props;

    if (node.type === type && node.object === "inline") {
      const href = node.data.get("href");
      const target = node.data.get("target");

      const className = node.data.get("class");
      const selectedLink = getFocusedLink(controller.value);
      const linkClassNames = classnames(className, { active: selectedLink && node.key === selectedLink.key });

      // Use react-router for relative paths
      if (href && href[0] === "/") {
        return (
          <>
            <RRLink to={href} target={target} className={linkClassNames} {...attributes}>{children}</RRLink>
            <EditTooltip linkNode={node} controller={controller} />
          </>
        );
      }
      else {
        return (
          <>
            <a href={href} target={target} className={linkClassNames} {...attributes}>{children}</a>
            <EditTooltip linkNode={node} controller={controller} />
          </>
        );
      }
    }
    else {
      return next();
    }
  },
};
